import { Dispatch } from 'redux';

import { requestBot } from '../../lib/request';

export const GET_REQUESTS_REQUEST = 'REQUESTS_GET_REQUESTS_REQUEST';
export const GET_REQUESTS_RESPONSE = 'REQUESTS_GET_REQUESTS_RESPONSE';
export const GET_REQUESTS_ERROR = 'REQUESTS_GET_REQUESTS_ERROR';

export const GET_REQUESTS_TYPES_REQUEST = 'REQUESTS_GET_REQUESTS_TYPES_REQUEST';
export const GET_REQUESTS_TYPES_RESPONSE = 'REQUESTS_GET_REQUESTS_TYPES_RESPONSE';
export const GET_REQUESTS_TYPES_ERROR = 'REQUESTS_GET_REQUESTS_TYPES_ERROR';

export const SET_REQUEST_TYPE = 'REQUESTS_SET_REQUEST_TYPE';

export const LIKE_REQUEST = 'REQUESTS_LIKE_REQUEST';
export const LIKE_RESPONSE = 'REQUESTS_LIKE_RESPONSE';
export const LIKE_ERROR = 'REQUESTS_LIKE_ERROR';

export const DISLIKE_REQUEST = 'REQUESTS_DISLIKE_REQUEST';
export const DISLIKE_RESPONSE = 'REQUESTS_DISLIKE_RESPONSE';
export const DISLIKE_ERROR = 'REQUESTS_DISLIKE_ERROR';

export const setRequestTypeAction = (requestType: string) => (dispatch: Dispatch<any>) => dispatch({
    type: SET_REQUEST_TYPE,
    requestType,
});

export const getRequestsAction = (
    userId: string,
    lang: string,
    show: string = 'active',
    page: number = 1,
    per: number = 25,
    types: string = '',
    getMore: boolean = false,
    ) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_REQUESTS_REQUEST,
        getMore,
    });

    return requestBot(`${process.env.REACT_APP_BOT_REG_SERVER}/api/client/v1/requests` +
        `?user_id=${userId}&lang=${lang}&page=${page}&per=${per}&types=${types === 'all' ? '' : types}&show=${show}`, {
        method: 'GET',
        headers: new Headers({
            'Authorization': `Basic ${process.env.REACT_APP_BOT_KEY}`,
        }),
    }).then(response => dispatch({
        type: GET_REQUESTS_RESPONSE,
        response,
        getMore,
    })).catch(error => dispatch({
        type: GET_REQUESTS_ERROR,
        error,
        getMore,
    }));
};

export const getRequestsTypesAction = (userId: string) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_REQUESTS_TYPES_REQUEST,
    });

    return requestBot(`${process.env.REACT_APP_BOT_REG_SERVER}/api/client/v1/requests/types` +
        `?user_id=${userId}`, {
        method: 'GET',
        headers: new Headers({
            'Authorization': `Basic ${process.env.REACT_APP_BOT_KEY}`,
        }),
    }).then(response => dispatch({
        type: GET_REQUESTS_TYPES_RESPONSE,
        response,
    })).catch(error => dispatch({
        type: GET_REQUESTS_TYPES_ERROR,
        error,
    }));
};

export const likeRequestAction = (requestId: number, userId: string) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: LIKE_REQUEST,
    });

    return requestBot(`${process.env.REACT_APP_BOT_REG_SERVER}/api/client/v1/requests/${requestId}/like?user_id=${userId}`, {
        method: 'POST',
        headers: new Headers({
            'Authorization': `Basic ${process.env.REACT_APP_BOT_KEY}`,
        }),
    }).then(response => dispatch({
        type: LIKE_RESPONSE,
        response,
    })).catch(error => dispatch({
        type: LIKE_ERROR,
        error,
    }));
};

export const dislikeRequestAction = (requestId: number, userId: string) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: DISLIKE_REQUEST,
    });

    return requestBot(`${process.env.REACT_APP_BOT_REG_SERVER}/api/client/v1/requests/${requestId}/dislike?user_id=${userId}`, {
        method: 'POST',
        headers: new Headers({
            'Authorization': `Basic ${process.env.REACT_APP_BOT_KEY}`,
        }),
    }).then(response => dispatch({
        type: DISLIKE_RESPONSE,
        response,
    })).catch(error => dispatch({
        type: DISLIKE_ERROR,
        error,
    }));
};



// WEBPACK FOOTER //
// ./src/actions/Requests/requests.ts